import styles from '../../../pages/Account/ExhibitorSetup/ExhibitorSetup.module.css'
import * as accountService from '../../../services/accountService'
const ChildItem = ({ index, child }) => {    
    const handleActivate = async e => {
        e.preventDefault()
        await accountService.activate(child.id);
    }
    const handleDeactivate = async e => {
        e.preventDefault()
        await accountService.deactivate(child.id);
    }
    return (
        <>
            <tr className={styles.trChilds} key={index}>
                <td className={styles.tdChilds}>{child.firstName} {child.lastName}</td>
                <td className={styles.tdChilds}> {child.userName}</td>
                <td className={styles.tdChilds}> {child.isDeleted && child.isDeleted === true ?
                    <button onClick={e => handleActivate(e)} className={styles.button}>Activate</button>
                    :
                    <button onClick={e => handleDeactivate(e)} className={styles.button}>Deactivate</button>}
                </td>           
            </tr>
        </>
    );
}

export default ChildItem;